export const FSTypeMap = {
    JP: 0,
    IFRS: 1,
    US: 2
};

export class FSTypeStateModel {
    constructor(obj) {
        this.Index = obj.Index;
        this.DisplayText = obj.DisplayText;
    }
}

export class AccountingStandardTypeStateModel {
    constructor(obj) {
        this.Value = obj.Value;
        this.Name = obj.Name;
        this.DisplayText = obj.DisplayText;
    }
}

export class SelectedFiscalPeriodStateModel {
    constructor(obj) {
        this.FiscalPeriodIndex = obj.FiscalPeriodIndex;
        this.AccTypeIndex = obj.AccTypeIndex;
        this.FsTypeIndex = obj.FsTypeIndex;
    }
}